import "./Loading.scss";
import defaultLoadingLogo from "../../assets/images/loading/Loading-Dual-Ball.svg";

const Loading = () => {
  // const serverAddress = process.env.REACT_APP_Server_Address
  // const logoUrl = localStorage.getItem("complex_logo")

  // const [logoUrl, setLogoUrl] = useState();
  // getUserInfo()
  //     .then(res => {
  //         res.logo ? setLogoUrl(res.logo) : null
  //     })
  //     .catch(err => {
  //         console.log(err);
  //     })

  return (
    <div className="LoadingBeforeFetchInfo">
      {/* <img className="logo" src={logoUrl ? serverAddress + logoUrl : defaultLoadingLogo} alt="logo" /> */}
      <img className="logo" src={defaultLoadingLogo} alt="logo" />
      <div className="loadingProgressBarContainer mt-4">
        <div className="loadingProgressBar"></div>
      </div>
      <span className="font-16 mt-3 iranyekan-bold">
        در حال دریافت اطلاعات...
      </span>
    </div>
  );
};

export default Loading;
